import axios from "axios";
import * as actions from "./actionsType";
import messages from "../../messages";
import toastr from "toastr";
import PlanIndividualServices from "./PlanIndividual.services";

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const getPlanIndividual = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_PLAN_INDIVIDUAL,
      payload: true,
    });

    const resp = await PlanIndividualServices.getPlanIndividual(filters);
    debugger
    dispatch({
      type: actions.GET_PLAN_INDIVIDUAL,
      payload: {
        planIndividual: resp.data
      },
    });
    dispatch({
      type: actions.PLAN_INDIVIDUAL_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.PLAN_INDIVIDUAL_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_PLAN_INDIVIDUAL,
      payload: false,
    });
  }
};


export const savePlanCurso =
  (data, setShowModal, filters) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.SAVE_LOADING_PLAN_INDIVIDUAL,
        payload: true,
      });
      await PlanIndividualServices.savePlanCursos(data);
      const resp = await PlanIndividualServices.getPlanIndividual(filters);
      debugger
      dispatch({
        type: actions.GET_PLAN_INDIVIDUAL,
        payload: {
          planIndividual: resp.data
        },
      });
      dispatch({
        type: actions.FORM_FAIL,
        payload: "",
      });
      setShowModal(false);
      toastr.success(messages.successMessage, " ", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 403:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.FORM_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.SAVE_LOADING_PLAN_INDIVIDUAL,
        payload: false,
      });
    }
  };

export const savePlanCompetencia =
  (data, setShowModal, filters) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.SAVE_LOADING_PLAN_INDIVIDUAL,
        payload: true,
      });
      await PlanIndividualServices.savePlanCompetencias(data);
      const resp = await PlanIndividualServices.getPlanIndividual(filters);
      debugger
      dispatch({
        type: actions.GET_PLAN_INDIVIDUAL,
        payload: {
          planIndividual: resp.data
        },
      });
      dispatch({
        type: actions.FORM_FAIL,
        payload: "",
      });
      setShowModal(false);
      toastr.success(messages.successMessage, " ", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 403:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.FORM_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.SAVE_LOADING_PLAN_INDIVIDUAL,
        payload: false,
      });
    }
  };

export const editPlanCurso =
  (data, id, index, setShowModal, filters) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.LOADING_PLAN_INDIVIDUAL,
        payload: true,
      });
      debugger
      await PlanIndividualServices.editPlanCursos(id, data);
      const resp = await PlanIndividualServices.getPlanIndividual(filters);
      debugger
      dispatch({
        type: actions.GET_PLAN_INDIVIDUAL,
        payload: {
          planIndividual: resp.data
        },
      });
      dispatch({
        type: actions.FORM_FAIL,
        payload: "",
      });
      setShowModal(false);

      toastr.success(messages.successMessage, " ", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 403:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.FORM_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.LOADING_PLAN_INDIVIDUAL,
        payload: false,
      });
    }
  };

export const editPlanCompetencias =
  (data, id, index, setShowModal, filters) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.LOADING_PLAN_INDIVIDUAL,
        payload: true,
      });
      await PlanIndividualServices.editPlanCompetencias(id, data);
      const resp = await PlanIndividualServices.getPlanIndividual(filters);
      debugger
      dispatch({
        type: actions.GET_PLAN_INDIVIDUAL,
        payload: {
          planIndividual: resp.data
        },
      });
      dispatch({
        type: actions.FORM_FAIL,
        payload: "",
      });
      setShowModal(false);

      toastr.success(messages.successMessage, " ", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 403:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.FORM_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.LOADING_PLAN_INDIVIDUAL,
        payload: false,
      });
    }
  };


export const deletePlanCurso = (id, index, filters) => async (dispatch, getState) => {
  try {

    dispatch({
      type: actions.LOADING_PLAN_INDIVIDUAL,
      payload: true,
    });
    debugger
    await PlanIndividualServices.deletePlanCursos(id);
    const resp = await PlanIndividualServices.getPlanIndividual(filters);
    debugger
    dispatch({
      type: actions.GET_PLAN_INDIVIDUAL,
      payload: {
        planIndividual: resp.data
      },
    });
    dispatch({
      type: actions.PLAN_INDIVIDUAL_FAIL,
      payload: "",
    });

    toastr.success(messages.successMessage, " ", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 403:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }

    dispatch({
      type: actions.PLAN_INDIVIDUAL_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_PLAN_INDIVIDUAL,
      payload: false,
    });
  }
};



export const deletePlanCompetencia = (id, index, filters) => async (dispatch, getState) => {
  try {

    dispatch({
      type: actions.LOADING_PLAN_INDIVIDUAL,
      payload: true,
    });
    await PlanIndividualServices.deletePlanCompetencias(id);
    const resp = await PlanIndividualServices.getPlanIndividual(filters);
    debugger
    dispatch({
      type: actions.GET_PLAN_INDIVIDUAL,
      payload: {
        planIndividual: resp.data
      },
    });
    dispatch({
      type: actions.PLAN_INDIVIDUAL_FAIL,
      payload: "",
    });

    toastr.success(messages.successMessage, " ", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 403:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }

    dispatch({
      type: actions.PLAN_INDIVIDUAL_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_PLAN_INDIVIDUAL,
      payload: false,
    });
  }
};
